import { useContext } from "react";
import PaginatorContext, { IPaginationModel } from "../context/PaginatorContext";

export function usePaginator(key: string, defaultPageSize = 25) {
  const { getModel, setModel } = useContext(PaginatorContext);
  const paginationModel = getModel(key, defaultPageSize);

  const setPaginationModel = (model: IPaginationModel) => setModel(key, model);
  const resetPage = () =>
    setModel(key, { ...paginationModel, page: 0 });

  return { paginationModel, setPaginationModel, resetPage };
}
